import LiteratureTitle from "@modules/Literature/LiteratureTitle";
import { FrontSiteRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card } from "semantic-ui-react";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import LiteratureCover from "@modules/Literature/LiteratureCover";
import { Truncate } from "@components/Truncate";
import { renderSubtitle } from "@modules/Document/utils";

export default class SpecialCollectionCard extends Component {
  render() {
    const { data, extra } = this.props;
    const metadata = data.metadata;
    const pid = metadata.pid;

    const title = metadata.title;
    const authors =
      metadata.authors && Array.isArray(metadata.authors)
        ? metadata.authors
            .map((a) => (typeof a === "string" ? a : a.full_name))
            .join(", ")
        : null;

    const publicationYear = metadata.publication_year;
    const department = metadata.academic_info?.department || "-";
    const program = metadata.academic_info?.program || "-";
    const subtitle = renderSubtitle(data.metadata?.alternative_titles);

    return (
      <Card
        centered
        className="fs-book-card"
        as={Link}
        to={FrontSiteRoutes.specialCollectionDetailsFor(data.metadata.pid)}
        data-test={pid}
      >
        <Card.Meta className="discrete">
          {metadata.collection_type || "Special Collection"}
        </Card.Meta>
        <LiteratureCover
          size="small"
          url={_get(metadata, "cover_metadata.urls.medium")}
        />
        <Card.Content>
          <Card.Header>
            <LiteratureTitle title={title} />
          </Card.Header>
          <Card.Meta>
            {subtitle}
            <Truncate lines={1}>{authors}</Truncate>
            <div>{publicationYear && <span> ({publicationYear})</span>}</div>
            <div>
              {department && <span>{department}</span>}
              {program && <span> | {program}</span>}
            </div>
          </Card.Meta>
        </Card.Content>
        {!_isEmpty(extra) && <Card.Content extra>{extra}</Card.Content>}
      </Card>
    );
  }
}

SpecialCollectionCard.propTypes = {
  data: PropTypes.object.isRequired,
  extra: PropTypes.node,
};

SpecialCollectionCard.defaultProps = {
  extra: null,
};
